import Conseils from "../util/Conseils1";


import OpacityComponent from "../util/OpacityComponent";

export default function Formation(){
    return(
        <div className="w-full overflow-hidden ">
        <Conseils/> 
        <OpacityComponent top="none"/>
        
    </div>)
}